import React, { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { VENDOR_BIDS_TABS } from 'utils/constants';
import CustomTabs from 'components/CustomTabs';
import ErrorBoundary from 'components/common/ErrorBoundary';
import VendorOfferBids from './components/VendorOfferBids';
import VendorDemandBids from './components/VendorDemandBids';

const VendorBids = () => {
  const [activeTab, setActiveTab] = useState(VENDOR_BIDS_TABS.OFFER);
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      {' '}
      <div className="d-flex align-items-center">
        <CustomTabs
          tabs={[VENDOR_BIDS_TABS.OFFER, VENDOR_BIDS_TABS.DEMAND]}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="full-border-tab"
        />
      </div>
      <TabContent activeTab={activeTab} className="mt-3">
        <TabPane tabId={VENDOR_BIDS_TABS.OFFER}>
          {activeTab === VENDOR_BIDS_TABS.OFFER && (
            <ErrorBoundary>
              <VendorOfferBids />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={VENDOR_BIDS_TABS.DEMAND}>
          {activeTab === VENDOR_BIDS_TABS.DEMAND && (
            <ErrorBoundary>
              <VendorDemandBids />
            </ErrorBoundary>
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default VendorBids;
